import axios from 'axios';
import { useState, useEffect } from 'react';
import { VendaTotalPorRota } from 'types/sales';
import { springPage } from 'types/vendor/springPage';
import { getTokenData } from 'utils/auth';
import { formatPrice } from 'utils/format';
import { BASE_URL } from 'utils/request';
import { getAuthData } from 'utils/storage';

const DataCalc = () => {
    const current = new Date();
    /*//////VALORESTÁTICO///////*/
    const date = `${current.getDate() + 3}`;
    const month = `${current.getMonth() + 1}`;
    const fullYear = `${current.getFullYear()}`;
    /*const result = current.getTime(); */

    const getDaysInMonth = (month: number, fullYear: number) => {
        return new Date(fullYear, month, 0).getDate();
    };

    const IntDate = parseInt(date)
    const untilDays = getDaysInMonth(parseInt(month), parseInt(fullYear));
    const workedDays = IntDate - untilDays / 7.5


    const [venda, setVenda] = useState<springPage<VendaTotalPorRota>>();

    useEffect(() => {
        axios.get(`${BASE_URL}/vendas/total-vendas-rota?rota=${getTokenData()?.user_name}`,
            { headers: { Authorization: "Bearer " + getAuthData().access_token } })
            .then((response) => {
                setVenda(response.data);
            })
    }, []);

    return (
        <div id="accordion">
            {venda?.content.map(item =>
                <div key={item.totalvenda} className="card m-3">
                    <h5 className="card-header bg-light text-primary text-uppercase">Tendencia</h5>
                    <div className="m-0 d-flex justify-content-center">
                        <h3 className="m-3">{formatPrice((item.totalvenda / workedDays) * untilDays)}</h3>
                        <span className="mt-3 mb-3 border-end d-flex flex-wrap"></span>
                        {/*////////////////////////VALOR TENDENCIA/////////////////////////////////////////////*/}
                        {/* <ValorMetaTendencia /> */}
                        {/*////////////////////////VALOR TENDENCIA/////////////////////////////////////////////*/}
                    </div>
                </div>

            )}
        </div>
    );
}

export default DataCalc;
